import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ProjectScopingBrokerService {
  public ProjectScopingItemsGridChangedEvent: BehaviorSubject<any>;
  public CancelChangesEvent: BehaviorSubject<any>;
  public SaveChangesEvent: BehaviorSubject<any>;
  public SaveChangesSuccessfulEvent: BehaviorSubject<any>;

  constructor() {
    this.ProjectScopingItemsGridChangedEvent = new BehaviorSubject(null);
    this.CancelChangesEvent = new BehaviorSubject(null);
    this.SaveChangesEvent = new BehaviorSubject(null);
    this.SaveChangesSuccessfulEvent = new BehaviorSubject(null);
  }
}